import { useContext, useEffect, useState } from "react";

import "./ProductSmall.scss";
import { Link } from "react-router-dom";
import { GlobalFunctionsContext } from "../../services/GlobalFunctionsContext";
import { AuthContext } from "../../services/AuthContext";
import { Button } from "react-bootstrap";
import { Cart } from "react-bootstrap-icons";
import { Percent, Tv } from "lucide-react";
import ButtonAddToCart from "./ButtonAddToCart";

export default function ProductSmall ({product, updateProduct, onVisible, onMessage}) {
  const { formatCurrency, convertStringToLink } = useContext(GlobalFunctionsContext);
  const { isAuthenticated, user } = useContext(AuthContext);
  const [nameLink, setNameLink] = useState('');

  useEffect(()=>{
    setNameLink(convertStringToLink(product.nombre));
  },[product])

  const saveScrollProd = (name) => {
    sessionStorage.setItem('idProductos', name);
  }

  return (
    <>
      <div className={"card " +( product.inCart ? 'in-cart' : '')} >
      <Link to={`/producto/${product.id}-${nameLink}`} onClick={()=>saveScrollProd(`product_${product.id}`)} id={`product_${product.id}`} className="producto">
          {product.en_tv
            ? <div className="en_tv">
              <Tv />
                En Tv
              </div> 
            : null}
          {product.fecha_dif < 60
          ? <div className="new">
              Novedad
            </div> 
          : null}
          {product.descuento > 0
          ? <div className={`promo ${product.en_tv ? 'down' : ''}`}>
              <Percent />
              Promo
            </div> 
          : null}
          { product.stock == 0
            ? <div className={`sin_stock ${product.fecha_dif < 60 ? 'down' : ''}`}>
                Sin Stock
              </div>
            : null
          }
          <div className="image">
            <img
              loading="lazy"
              src={product.preview}
              alt={product.nombre}
            />
          </div>
          <div className="description ">
            <div className="categ">
              <div className="brand">{product.marca}</div>
              <div className="sku">sku: {product.sku}</div>
            </div>
            <div className="descrition-data">
            <div className="name">{product.nombre}
              <div className="note">
                {product.embalaje_uno
                  ? product.nombre_embalaje_uno + ': ' + product.cant_embalaje_uno +
                    (product.embalaje_dos
                      ? ' | ' + product.nombre_embalaje_dos + ': '+ product.cant_embalaje_dos
                      : '')
                  : null}
              </div>
            </div>
            {product.cantInCart > 0
              ?<div className="cart-message">
              <strong>{product.cantInCart} en tu carrito</strong></div>
              : null}
            
            {isAuthenticated &&
              <div className="price">
                {user.disc_visib || product.descuento > 0
                  ? <div className="original-price">$ {formatCurrency(!user.disc_visib ? product.precio * (1-user.discount/100) : product.precio)}</div>
                  : null
                }
                <div className="price-wrapper">
                  <span className="sign">$</span>
                    {user.discount > 0 && !user.disc_visib
                      ? product.descuento > 0
                        ? formatCurrency((product.precio*(1-product.descuento/100))*(1-user.discount/100))
                        : <>{formatCurrency(product.precio*(1-user.discount/100))}</>
                      : user.disc_visib || product.descuento > 0
                        ? formatCurrency(product.precio*(1-product.descuento/100)*(1-user.discount/100))
                        : <>{formatCurrency(product.precio)}</>
                    }
                  <span>+ iva</span>
                  {(user.disc_visib && user.discount > 0) || product.descuento > 0
                    ? <div className="discount">{user.disc_visib ? Number((1-((1-user.discount/100) * (1-product.descuento/100)))*100).toFixed(1): product.descuento}% off</div>
                    : null
                  }
                </div>
              </div>
            }
            </div>
            {!isAuthenticated 
              ? <div>Ingrese para ver los precios</div>
              : product.variedades > 0 
                ? <div className="btn-content">
                    <Button variant="primary" className="small">Agregar al carrito <Cart /></Button>
                  </div>
                : <div className="btn-content">
                    <ButtonAddToCart product={product} small={true} updateProduct={updateProduct} onVisible={onVisible} onMessage={onMessage}/>
                </div>
            }
          </div>
        </Link>
      </div>
    </>
  );
}

